import {quranCopy} from './quranCopy';
import {journeyCopy} from './journeyCopy';
import {physicalLibraryCopy} from './physicalLibraryCopy';
import { persianTranslations } from './persianTranslations';
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { messages, languageLabels } from "./messages";
import { subpageMessages } from "./subpageMessages";
import { pageDescriptions } from "./pageDescriptions";
import { subpageNotes } from "./subpageNotes";
import { formMessages } from "./formMessages";
import mahmutAiCopy from "./mahmutAiCopy";
import { navigationLabels } from "./navigationLabels";
const physicalLabels=language=>Object.fromEntries(["name","intro","digital","cta","physicalBooks","shelfLabel"].map(key=>[physicalLibraryCopy.tr[key],physicalLibraryCopy[language][key]]));
const dictionaries=Object.fromEntries(Object.keys(messages).map(language=>[language,{...physicalLabels(language),...(language === "fa" ? persianTranslations : {}),...messages[language],...subpageMessages[language],...pageDescriptions[language],...subpageNotes[language],...formMessages[language],...navigationLabels[language],...journeyCopy[language],...(quranCopy[language] || quranCopy.en),["Mahmut Efendim AI’ı aç"]:mahmutAiCopy[language][1]}]));
export function translateText(locale,source,parameters={}) {
  if(typeof source!=="string")return source;
  const dictionary=dictionaries[locale]||dictionaries.tr;
  let value=dictionary[source];
  if(value==null){
    const match=source.match(/^(← |\/ | · )?(.+?)(:| →)?$/);
    value=match&&dictionary[match[2]]?(match[1]||"")+dictionary[match[2]]+(match[3]||""):source;
  }
  return value.replace(/\{(v\d+)\}/g,(token,key)=>Object.prototype.hasOwnProperty.call(parameters,key)?String(typeof parameters[key]==='string'?translateText(locale,parameters[key]):parameters[key]):token);
}
const LocaleContext = createContext(null);
export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    try { const saved = localStorage.getItem("sayyadi-locale"); return messages[saved] ? saved : "tr"; }
    catch { return "tr"; }
  });
  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = ["ar", "fa"].includes(locale) ? "rtl" : "ltr";
    try { localStorage.setItem("sayyadi-locale", locale); } catch {}
  }, [locale]);
  const value = useMemo(() => ({ locale,
    setLocale: (next) => { if (messages[next]) setLocale(next); },
    t: (source, parameters) => translateText(locale,source,parameters),
  }), [locale]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}
export function useLocale() {
  const value = useContext(LocaleContext);
  if (!value) throw new Error("LocaleProvider is required");
  return value;
}
export function LanguagePicker() {
  const { locale, setLocale } = useLocale();
  return <label className="inline-flex items-center gap-2 text-xs">
    <span className="sr-only">Dil / Language</span>
    <select data-testid="language-picker" aria-label="Dil / Language" value={locale}
      onChange={(event) => setLocale(event.target.value)}
      className="min-h-[44px] max-w-[150px] rounded-full border px-3 text-xs"
      style={{ color: "var(--sy-gold-bright)", background: "var(--sy-panel)", borderColor: "var(--sy-border)" }}>
      {Object.entries(languageLabels).map(([code, name]) => <option key={code} value={code}>{name}</option>)}
    </select>
  </label>;
}
